import React, { useState, useEffect } from 'react';

// The one place a coach's face is drawn.
//
// NEVER A BROKEN IMAGE ICON. There are only two things this can show: the
// photo, or a flat circle with the coach's initials. No photo, a photo that
// will not load, a coach with no name at all — every one of those lands on the
// initials circle. The little torn-page icon a browser draws for a failed
// image looks like the portal is broken, and it would be on screen next to
// somebody's name.
//
// The picture arrives as a data URI inside JSON the page has already loaded,
// so there is no object URL created here and nothing to revoke. See the note
// at the top of backend/src/routes/profile.js for why it works that way.

const initialsOf = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// size: 'sm' 28px (table rows) | 'md' 32px (top bar) | 'lg' 112px (profile page)
const Avatar = ({ name, src, size = 'sm', className = '' }) => {
  const [failed, setFailed] = useState(false);

  // A replaced photo is a new data URI, so this clears the previous failure
  // and gives the new one a fair go.
  useEffect(() => { setFailed(false); }, [src]);

  const classes = `avatar avatar-${size} ${className}`.trim();

  if (!src || failed) {
    return (
      <span className={`${classes} avatar-initials`} aria-hidden="true">
        {initialsOf(name)}
      </span>
    );
  }

  return (
    <img
      className={classes}
      src={src}
      // The name is already next to this on screen in every case, so the
      // picture is decoration and repeating the name would just make a screen
      // reader say it twice.
      alt=""
      aria-hidden="true"
      onError={() => setFailed(true)}
    />
  );
};

export { initialsOf };
export default Avatar;
